import classes from './Icons.module.scss'

export function TriangleIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="19" viewBox="0 0 23 19" fill="none">
            <path d="M10.634 0.666991C11.0189 0.000324309 11.9811 0.000325441 12.366 0.666992L21.8923 17.167C22.2772 17.8337 21.7961 18.667 21.0263 18.667H1.97372C1.20392 18.667 0.722795 17.8337 1.1077 17.167L10.634 0.666991Z" fill="white" />
        </svg>
    );
}

export function PolygonIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M9.5 0.288675C9.8094 0.110042 10.1906 0.110042 10.5 0.288675L18.5933 4.96132C18.9027 5.13996 19.0933 5.47008 19.0933 5.82735V15.1726C19.0933 15.5299 18.9027 15.86 18.5933 16.0387L10.5 20.7113C10.1906 20.89 9.8094 20.89 9.5 20.7113L1.40673 16.0387C1.09733 15.86 0.906734 15.5299 0.906734 15.1726V5.82735C0.906734 5.47009 1.09733 5.13996 1.40673 4.96132L9.5 0.288675Z" fill="white" />
        </svg>
    );
}

export function StarIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
            <path d="M10.0489 1.09405C10.3483 0.172734 11.6517 0.172732 11.9511 1.09404L13.6942 6.45879C13.828 6.87081 14.212 7.14977 14.6452 7.14977H20.2861C21.2548 7.14977 21.6576 8.38939 20.8738 8.95879L16.3103 12.2744C15.9598 12.529 15.8132 12.9804 15.947 13.3924L17.6902 18.7572C17.9895 19.6785 16.935 20.4446 16.1513 19.8752L11.5878 16.5596C11.2373 16.305 10.7627 16.305 10.4122 16.5596L5.84869 19.8752C5.06498 20.4446 4.0105 19.6785 4.30985 18.7572L6.05296 13.3924C6.18683 12.9804 6.04018 12.529 5.68969 12.2744L1.12616 8.95879C0.342451 8.38939 0.745225 7.14977 1.71395 7.14977H7.35477C7.788 7.14977 8.17196 6.87081 8.30583 6.45879L10.0489 1.09405Z" fill="white" />
        </svg>
    );
}

export function CircleIcon() {
    return (
        <div className={classes.circleIcon} />
    );
}

export function CubicIcon() {
    return (
        <div className={classes.cubicIcon} />
    );
}

export function XIcon() {
    return (
        <div className={classes.xIcon}>
            <div />
            <div />
        </div>
    );
}

export function ButtonSendIcon(props) {
    const { colorFill, colorBorder, className } = props;

    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="65" viewBox="0 0 64 65" fill="none" className={className}>
                <g filter="url(#filter0_d_311_18837)">
                    <circle cx="32" cy="32" r="32" fill={colorFill} fillOpacity="0.75" shapeRendering="crispEdges" />
                    <circle cx="32" cy="32" r="31.5" stroke={colorBorder} shapeRendering="crispEdges" />
                </g>
                <defs>
                    <filter id="filter0_d_311_18837" x="0" y="0" width="64" height="65" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dy="1" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.0666667 0 0 0 0 0.12549 0 0 0 0 0 0 0 0 0.6 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_311_18837" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_311_18837" result="shape" />
                    </filter>
                </defs>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M23.2827 0.716072C24.2391 1.67083 24.2391 3.21881 23.2827 4.17357L10.1501 17.2839C9.19367 18.2387 7.64306 18.2387 6.68668 17.2839L0.71729 11.3247C-0.239097 10.3699 -0.239097 8.82194 0.71729 7.86717C1.67368 6.91241 3.22428 6.91241 4.18067 7.86717L8.41837 12.0977L19.8193 0.716072C20.7757 -0.238691 22.3263 -0.238691 23.2827 0.716072Z" fill="#447308" />
            </svg>
        </>
    );
}

export function PrevIcon(props) {
    const {color} = props;
    return (
        <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.70711 0.792893C7.31658 0.402369 6.68342 0.402369 6.29289 0.792893L0.292893 6.79289C-0.0976315 7.18342 -0.0976315 7.81658 0.292893 8.20711L6.29289 14.2071C6.68342 14.5976 7.31658 14.5976 7.70711 14.2071C8.09763 13.8166 8.09763 13.1834 7.70711 12.7929L2.41421 7.5L7.70711 2.20711C8.09763 1.81658 8.09763 1.18342 7.70711 0.792893Z" fill={color} />
        </svg>
    )
}

export function NextIcon(props) {
    const {color} = props;
    return (
        <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.292893 0.792893C0.683417 0.402369 1.31658 0.402369 1.70711 0.792893L7.70711 6.79289C8.09763 7.18342 8.09763 7.81658 7.70711 8.20711L1.70711 14.2071C1.31658 14.5976 0.683417 14.5976 0.292893 14.2071C-0.0976311 13.8166 -0.0976311 13.1834 0.292893 12.7929L5.58579 7.5L0.292893 2.20711C-0.0976311 1.81658 -0.0976311 1.18342 0.292893 0.792893Z" fill={color}  />
        </svg>
    )
}

export function SkipIcon(props) {
    const {color} = props;

    return (
        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L4.58579 6L0.292893 10.2929C-0.0976311 10.6834 -0.0976311 11.3166 0.292893 11.7071C0.683417 12.0976 1.31658 12.0976 1.70711 11.7071L6.70711 6.70711C7.09763 6.31658 7.09763 5.68342 6.70711 5.29289L1.70711 0.292893ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893C6.90237 0.683417 6.90237 1.31658 7.29289 1.70711L11.5858 6L7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071C7.68342 12.0976 8.31658 12.0976 8.70711 11.7071L13.7071 6.70711C14.0976 6.31658 14.0976 5.68342 13.7071 5.29289L8.70711 0.292893Z" fill={color}  />
        </svg>
    )
}

export function SendIcon(props) {

    const {color} = props;

    return (
        <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.36033 17.6499C5.62272 17.4292 3.91515 16.8883 2.98577 16.4909C1.82403 15.9941 1.27083 14.2279 2.98577 13.2344C4.70071 12.2409 22.1267 1.75409 22.9565 1.25734C23.7864 0.760597 26.3311 0.981373 25.8332 2.96835C25.3353 4.95534 21.7948 20.2992 21.6842 20.8512C21.5735 21.4031 20.965 23.1141 18.9181 22.3414C18.0074 21.9976 16.3356 21.3532 14.7138 20.7256M6.36033 17.6499L18.9181 8.10139L11.3392 19.4161C12.1576 19.7346 13.4197 20.2248 14.7138 20.7256M6.36033 17.6499L10.3987 25.8738L14.7138 20.7256" stroke={color}  strokeWidth="2" strokeLinejoin="round" />
        </svg>
    )
}